import { ColumnConfiguration, GridData } from 'api/models/table';
import { v4 as uuidv4 } from 'uuid';

export type PayerGroup = {
  id: string;
  isNew: boolean;
  ooPayerGroupKey: string;
  payerGroup: string;
  createdDate: Date;
  createdBy: string;
  updatedDate: Date;
  updatedBy: string;
};

//TODO: Return columns from API endpoint
const payerGroupColumns: ColumnConfiguration[] = [
  {
    name: 'payerGroup',
    displayName: 'Payer Group Name',
    type: 'string',
    required: true,
    defaultValue: '',
    editable: true,
    flex: 1,
  },
  {
    name: 'updatedBy',
    displayName: 'Last Updated By',
    type: 'string',
    required: true,
    defaultValue: '',
    editable: false,
    flex: 1,
  },
  {
    name: 'updatedDate',
    displayName: 'Last Updated Date',
    type: 'date',
    required: true,
    defaultValue: new Date().toUTCString(),
    editable: false,
    flex: 1,
  },
  {
    name: 'actions',
    type: 'actions',
    displayName: 'Actions',
    width: 100,
    cellClassName: 'actions',
    required: true,
    editable: false,
    defaultValue: '',
  },
];

// Transform the api returned flex data to a format that can be consumed by UI table/grid
export const convertPayerGroupToDataGrid = (
  payerGroups: PayerGroup[]
): GridData => {
  const rows = payerGroups.map(payerGroup => ({
    ...payerGroup,
    id: uuidv4(),
    isNew: false,
  }));

  return {
    columns: payerGroupColumns,
    rows: rows,
  };
};
